import { FixedSizeList } from 'react-window';
import InvestigationIcon from '../common/Images/investigation_white.png';
import EntityCard from './EntityCard';
import { useMediaQuery, useTheme } from '@material-ui/core';
import InvestigationDrawer from '../InvestigationDrawer/InvestigationDrawer';
import React from 'react';
import { useAppDrawer } from '../AppDrawer/AppDrawerProvider';

const EntityListItem = ({ data, index, style }) => {
    const { entitiesData, setCurrentEntityIndex, currentEntityIndex, entityType, showGoToInvestigation } = data;
    const isSelected = currentEntityIndex === index;
    const isLast = index === entitiesData.length - 1;
    const { displayContent } = useAppDrawer();

    return (
        <div
            style={style}
            onClick={() => setCurrentEntityIndex(index)}
            className={`flex cursor-pointer p-2 items-center justify-between${isSelected ? ' bg-sf-primary-700' : ''}${
                !isLast && !isSelected ? ' border-b border-sf-dark-400' : ''
            }`}>
            <span className="w-15 whitespace-nowrap overflow-hidden text-14 font-sf text-center text-ellipsis text-sf-white">
                {entitiesData[index].name}
            </span>
            {isSelected && showGoToInvestigation && (
                <span
                    className="flex items-center justify-center w-6 h-6 bg-sf-primary rounded"
                    title={'Investigate'}
                    rel="noopener noreferrer"
                    onClick={() => {
                        displayContent(
                            <InvestigationDrawer
                                guid={entitiesData[index].guid}
                                adType={entityType.adType}
                            />
                        );
                    }}>
                    <img src={InvestigationIcon} className="w-4 h-4 fill-white" alt="investivate icon" />
                </span>
            )}
        </div>
    );
};

const MultipleEntitiesCard = ({
    entityData = {},
    entitiesData = [],
    setCurrentEntityIndex,
    currentEntityIndex,
    entityType,
    showBox = true,
    customFieldsToShow,
    customDetailsClass = '',
    showMemberships,
    listHeight = 250,
    listWidth = 150,
    listItemSize = 40,
    showGoToInvestigation
}) => {
    const theme = useTheme();
    const extraLargeScreen = useMediaQuery(theme.breakpoints.up('xl'));

    return (
        <div
            className={`grid ${
                entitiesData.length > 1 ? 'grid-cols-[min-content_auto]' : 'grid-cols-1'
            } p-4 w-full h-full ${showBox ? 'shadow-sf-medium px-0 py-4 rounded-lg bg-sf-dark-600' : ''}`}>
            {entitiesData.length > 1 && (
                <FixedSizeList
                    height={listHeight}
                    itemCount={entitiesData.length}
                    itemSize={listItemSize}
                    itemData={{
                        entitiesData,
                        setCurrentEntityIndex,
                        currentEntityIndex,
                        entityType,
                        showGoToInvestigation
                    }}
                    width={listWidth}>
                    {EntityListItem}
                </FixedSizeList>
            )}
            <EntityCard
                entityData={entityData}
                entityType={entityType}
                showMemberships={showMemberships}
                showBox={showBox}
                customFieldsToShow={customFieldsToShow}
                customDetailsClass={customDetailsClass}
                showGoToInvestigation={showGoToInvestigation && entitiesData.length === 1}
                showEntityId={extraLargeScreen || entitiesData.length === 1}
            />
        </div>
    );
};

export default MultipleEntitiesCard;
